
bsCustomFileInput.init();

$.fn.select2.defaults.set("selectOnClose", true);

window.disableFormGroup = function (formGroup) {
    formGroup.addClass('disabled');
    formGroup.find('input').val('').attr('disabled', true);
};

window.enableFormGroup = function (formGroup) {
    formGroup.removeClass('disabled');
    formGroup.find('input').attr('disabled', false);
};

$(function () {
    $('[data-toggle="tooltip"]').tooltip();

    $('table .row-link').click(function () {
        window.location = $(this).data('href');
    });

    // remember the hash in the URL without jumping
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        if (history.pushState) {
            history.pushState(null, null, '#' + $(e.target).attr('href').substr(1));
        } else {
            location.hash = '#' + $(e.target).attr('href').substr(1);
        }
    });

    $(document).on('click', '.clear-input', function () {
        $(this).closest('.input-group').find('input').val('').trigger('change');
    });
});
